import {cx} from "@emotion/css";

import {MediaVideoComponent} from "@/app/pages/upik/MediaVideo/MediaVideo";
import {classCombinerFromPrefix} from "@/app/pages/upik//resources/RenderIdentifier";
import {SecondTabProps} from "@/app/pages/upik/resources/interfacesData";
import ThumbnailImage from "@/app/pages/upik/resources/videoThumbnail.png";
import SearchTabsStyles from "@/app/pages/upik//styles/SearchTabsStyles.module.scss";
import {HeadingContent} from "@/app/pages/upik/components/HeadingContent";
import React from "react";

const styles = SearchTabsStyles;
const classCombiner = classCombinerFromPrefix("6e1124ea8c05f948");

interface HeadingContentInterface {
    content: string;
    heading: string;
}

const defaultVideoId = "Q2DrBKzM_Do";

const WhatDunsNumberTab = ({
    answerOneTabTwoLocalized,
    isFullwidthVideo,
    questionOneTabTwoLocalized,
    upikVideoId,
    upikVideoThumbnailImage,
    language
}: SecondTabProps): JSX.Element => {
    const DunsNumberData: HeadingContentInterface = {
        "content": language === 'de' ? `Die D&B D-U-N-S® Nummer (Data Universal Numbering System) ist ein "nicht-sprechender" 9-stelliger Zahlenschlüssel zur weltweiten und eindeutigen Identifizierung von Unternehmen. Er wurde von Dun & Bradstreet 1962 eingeführt und ist heute der Schlüssel zu Daten von weltweit mehreren hundert Millionen Unternehmen.` : "The D&B D-U-N-S<sup>®</sup> Number (Data Universal Numbering System) is a non-speaking 9-digit numbering key for the worldwide and unique identification of companies. It was introduced by D&B in 1962 and is today the key to data on hundreds of million companies worldwide.",
        "heading": language === 'de' ? "Was ist die D&B D-U-N-S® Nummer?" : "What is the D&B D-U-N-S<sup>®</sup> Number?"
    };
    return (
    <div>
        <HeadingContent
            content={answerOneTabTwoLocalized ?? DunsNumberData.content}
            heading={questionOneTabTwoLocalized ?? DunsNumberData.heading}
        />

        <div className={cx(classCombiner(styles, "textAlignCenterAndMargin"))}>
            <MediaVideoComponent
                fullwidthVideo={isFullwidthVideo ?? false}
                showMissingVideoIdWarning={true}
                thumbnailImage={upikVideoThumbnailImage ?? ThumbnailImage}
                videoId={upikVideoId ?? defaultVideoId}
            />
        </div>
    </div>
    )
}

export {WhatDunsNumberTab};
